module.exports = __webpack_public_path__ + "static/media/arrow-right-dark.0760b978.svg";